/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import SearchPublicVacancie from './search-vacancy';
import { stylePublicVac } from './style-public-vacancie';
import Logo from "../../images/sae.png";
import ModalConfirmBase from '../../utils/form/modalConfirmBase';
import TablePublicVacancies from './table-public-vacancies';
import { useStateValue } from "../../context/store";
import {
  getFilterPublicVacancies,
  } from "../../actions/vacant-actions";
  import { getContractTypeForGenerate } from "../../actions/generation-contarct-action";

import { TablePagination, Typography } from '@material-ui/core';
import Search from "../../images/icons/search.svg";


const PublicVacancie = (props) => {
    const classes = stylePublicVac();
    const [{ filterPublicVacant }, dispatch] = useStateValue();
    const [contractTypes,setContractTypes] = useState([])

    const [message, setMessage] = useState({
        description: "",
        textButtonSubmit: "",
        handleClick: () => {},
        handleClickOut: () => {},
        oneButtons: false,
        type: "",
        open: false,
    });


    const [filter, setFilter] = useState({
      salaryMin: null,
      salaryMax: null,
      charge:null,
      regional: null,
    });

    const [paginadorRequest, setPaginadorRequest] = useState({
      page: 0,
      size: 10,
      order: "DESC",
      columnOrder: "creationDate",
    });

    const [paginadorResponse, setPaginadorResponse] = useState({
      data: [],
      totalRows: 0,
      pageSize: 0,
      pageNumber: 0,
    });

    useEffect(() => {
      const getContracTypeList = async () => {
        const contracTypeList = await getContractTypeForGenerate();
        setContractTypes(contracTypeList.data)
        };
      getContracTypeList();

    }, []);

    const getVacants = async () => {
      const response = await getFilterPublicVacancies(
        {
          minSalary: filter.salaryMin === "" ? null : filter.salaryMin,
          maxSalary: filter.salaryMax === "" ? null : filter.salaryMax,
          chargeRequested: filter.charge === "" ? null : filter.charge,
          regional: filter.regional === "" ? null : filter.regional,
        },
        {
          page: paginadorRequest.page,
          size: paginadorRequest.size,
          order: paginadorRequest.order,
          columnOrder: paginadorRequest.columnOrder,
        },
        dispatch
      );
      if (response.data) {
        const data = response.data.vacantResponsePage;
        if (data.content?.length > 0) {
          setPaginadorResponse({
            data: data.content,
            totalRows: data.totalElements,
            pageSize: data.size,
            pageNumber: data.number,
          });
        }
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    };

    useEffect(() => {
      getVacants();
      dispatch({
        type: "SET_BREADCRUMB",
        breadCrumbText: "Vacantes",
        breadCrumbSubText: "Vacantes",
        index: 104,
      });
    }, [paginadorRequest]);

    if (
      filterPublicVacant &&
      filterPublicVacant?.isFilter &&
      filter !== filterPublicVacant.filter
    ) {
      var newfilter = filterPublicVacant.filter;
      filter.salaryMin = newfilter.salaryMin;
      filter.salaryMax = newfilter.salaryMax;
      filter.charge = newfilter.charge;
      filter.regional = newfilter.regional;
      paginadorRequest.page = 0;
      getVacants();
      dispatch({
        type: "SET_PUBLIC_VACANCY_FILTER",
        isFilter: false,
      });
    }

    const handleClickCloseMessage = () => {
        setMessage({...message, open: false});
    };

    const handleClickClose = () => {
        'https://cuidadoseguro.com.co/principal/'
    };

    const handleClickOpenModal = () => {
        setMessage({
            description: `¿Está seguro que desea aplicar a esta vacante ?`,
            textButtonSubmit: "Aceptar",
            handleClick: () => redirectMessage(),
            handleClickOut: () => handleClickCloseMessage(),
            type: "WARNING",
            open: true,
          });
    }

    const redirectMessage = () => {
        setMessage({
            description: `Señor usuario para aplicar a esta vacante, usted debe iniciar sesión en el sistema`,
            textButtonSubmit: "Aceptar",
            handleClick: () => redirectLogin(),
            handleClickOut: () => handleClickCloseMessage(),
            type: "WARNING",
            open: true,
          });
    }

    const redirectLogin = () => {
        props.history.push('/auth/login');
    }

    const changePage = (event, nuevaPagina) => {
      setPaginadorRequest((anterior) => ({
        ...anterior,
        page: parseInt(nuevaPagina),
      }));
    };

    const changeAmountOfRecords = (event) => {
      setPaginadorRequest((anterior) => ({
        ...anterior,
        size: parseInt(event.target.value),
        page: 0,
      }));
    };

    return (
        <div className={classes.container}>
            <div className={classes.containerOne}>
                <img
                    src={Logo}
                    width="100"
                    height="29"
                    alt=""
                    style={{
                    paddingLeft: "20px",
                    marginRight: 15,
                    cursor: "pointer",
                    }}
                />
            </div>
            <div className={classes.containerTwo}>
                <h4 className={classes.titleVacancies} >Vacantes</h4>
            </div>
            <div className={classes.containerBody}>
                <div className={classes.containerSearch}>
                    <SearchPublicVacancie/>
                </div>

                {
                    paginadorResponse?.data?.map((data) => (
                        <TablePublicVacancies
                            data={data}
                            handleClickClose={handleClickClose}
                            handleClickOpenModal={handleClickOpenModal}
                            contractTypes={contractTypes}
                        />
                    ))
                }

                {paginadorResponse.totalRows !== 0 ? (
                        <TablePagination
                          style={{ display: "flex", justifyContent: "center" }}
                          rowsPerPageOptions={[5, 10, 15]}
                          count={paginadorResponse.totalRows}
                          rowsPerPage={paginadorRequest.size}
                          page={paginadorRequest.page}
                          onChangePage={changePage}
                          onChangeRowsPerPage={changeAmountOfRecords}
                          labelRowsPerPage="Registros por página"
                        />
                      ) : (
                        <div>
                          <div
                            style={{
                              justifyContent: "center",
                              flexDirection: "column",
                              alignItems: "center",
                              marginTop: "10%",
                              display: "flex",
                            }}
                          >
                            <img src={Search} alt="" />
                            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
                              No se encontraron registros que coincidan con el filtro de
                              búsqueda aplicado.
                            </Typography>
                          </div>
                        </div>
                      )}
            </div>

            <ModalConfirmBase
                description={message.description}
                textButtonSubmit={message.textButtonSubmit}
                handleClick={message.handleClick}
                handleClickOut={message.handleClickOut}
                oneButtons={message.oneButtons}
                type={message.type}
                open={message.open}
            />
        </div>
    )
}

export default PublicVacancie;